import { render, staticRenderFns } from "./AskAIModal.vue?vue&type=template&id=31496f73&scoped=true"
import script from "./AskAIModal.vue?vue&type=script&lang=js"
export * from "./AskAIModal.vue?vue&type=script&lang=js"
import style0 from "./AskAIModal.vue?vue&type=style&index=0&id=31496f73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31496f73",
  null
  
)

export default component.exports